import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Dropdown } from 'react-bootstrap'

import ModalCreateUpdate from 'pages/main/preparationPlaces/ModalCreateUpdate'
import DeleteModal from 'pages/parts/DeleteModal'
import { httpOk, GET, POST, PUT, DELETE } from 'helpers/api'

function getDefaultItem(posId) {
	return {
		name: '',
		pos_id: posId || null,
	}
}

function Index() {
	const { t } = useTranslation()
	const reduxAccount = useSelector(state => state.account)

	const [data, setData] = useState([])
	const [selectedItem, setSelectedItem] = useState(getDefaultItem(reduxAccount.pos_id))
	const [modalCreateUpdate, setModalCreateUpdate] = useState(false)
	const [modalDelete, setModalDelete] = useState(false)
	const [deleteModalParams, setDeleteModalParams] = useState({ id: 0 })

	async function searchWithFilter(posId = reduxAccount.pos_id) {
		if (!posId) {
			setData([])
			return
		}

		const response = await GET(`/preparation-places?pos_id=${posId}`, {}, { loader: true })
		if (httpOk(response)) setData(response.data)
	}

	async function toggleModalCreateUpdate(bool = false, item = getDefaultItem(reduxAccount.pos_id)) {
		setSelectedItem(bool ? { ...getDefaultItem(reduxAccount.pos_id), ...item, pos_id: reduxAccount.pos_id } : getDefaultItem(reduxAccount.pos_id))
		setModalCreateUpdate(bool)
	}

	async function createUpdate(e) {
		e.preventDefault()

		const payload = {
			id: selectedItem.id,
			name: selectedItem.name,
			pos_id: reduxAccount.pos_id,
		}

		let response
		if (payload.id) {
			response = await PUT('/preparation-places', payload, { loader: true })
		} else {
			response = await POST('/preparation-places', payload, { loader: true })
		}

		if (httpOk(response)) {
			toggleModalCreateUpdate()
			searchWithFilter(reduxAccount.pos_id)
		}
	}

	async function deleteItem() {
		const response = await DELETE(`/preparation-places/${deleteModalParams.id}`, {}, { loader: true })
		if (httpOk(response)) {
			setModalDelete(false)
			searchWithFilter(reduxAccount.pos_id)
		}
	}

	useEffect(() => {
		searchWithFilter(reduxAccount.pos_id)
	}, [reduxAccount.pos_id]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('preparation_places')} [{data.length}]
				</h4>
				<div className="d-flex">
					<button className="btn-rounded btn btn-primary"
						onClick={() => toggleModalCreateUpdate(true)}>
						{t('create')}
					</button>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ minWidth: '33px' }} className="text-center">#</th>
									<th style={{ width: '30%' }}>{t('name2')}</th>
									<th style={{ width: '10%' }} className="text-end">{t('products')}</th>
									<th style={{ width: '60%' }}></th>
									<th style={{ minWidth: '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data?.map((item, index) => (
									<tr key={item.id || index}>
										<td className="text-center">{index + 1}</td>
										<td className="td-ellipsis">{item.name}</td>
										<td className="text-end">{item.products ?? 0}</td>
										<td></td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<div className="table-dropdown-item"
															onClick={() => toggleModalCreateUpdate(true, item)}>
															<i className="uil-edit-alt"></i>
															{t('edit')}
														</div>
														<div className="table-dropdown-item text-danger"
															onClick={() => {
																setDeleteModalParams({ id: item.id })
																setModalDelete(true)
															}}>
															<i className="uil-trash-alt"></i>
															{t('delete')}
														</div>
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			<ModalCreateUpdate
				selectedItem={selectedItem}
				setSelectedItem={setSelectedItem}
				createUpdate={createUpdate}
				modalCreateUpdate={modalCreateUpdate}
				toggleModalCreateUpdate={toggleModalCreateUpdate}
			/>

			<DeleteModal
				modalDelete={modalDelete}
				setModalDelete={setModalDelete}
				deleteItem={deleteItem}
			/>
		</>
	)
}

export default Index
